import React from 'react';

const useSaveAsDraft = () => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    React.useState(false);

  const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);

  return {
    isConfirmationModalOpen,
    isSuccessModalOpen,
    setIsConfirmationModalOpen,
    setIsSuccessModalOpen,
  };
};

export default useSaveAsDraft;
